import { useEffect, useState } from "react";

const UPDATE_INTERVAL_MS = 30_000;

export const useCurrentTime = () => {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    const interval = window.setInterval(() => setNow(new Date()), UPDATE_INTERVAL_MS);

    return () => window.clearInterval(interval);
  }, []);

  return now;
};
